import { RouterProvider } from 'react-router';

import { createAppRouter } from './router';
import { Providers } from './providers';

// Один роутер на процесс: `createBrowserRouter` подписывается на историю браузера, и второй
// экземпляр перехватывал бы её у первого.
const router = createAppRouter();

export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
